import React from 'react'
import ProductList from '../components/products/ProductList'

function ProductPage() {
  return (
    <div className='products-page'>
        <ProductList/>
    </div>
  )
}

export default ProductPage